module.exports = __webpack_public_path__ + "img/inspiration_04.d390224.webp";